/// <amd-module name="Build/Admin/PoolsList/PoolsListView" />
import * as React from "react";

import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { IVssPageService } from "VSS/Platform/Page";
import { IVssPerformanceService } from "VSS/Platform/Performance";

import { ServiceIds, Telemetry } from "Build/Admin/Common/Constants";
import { HeaderBreadcrumbService } from "Build/Admin/Common/Services/HeaderBreadcrumbService";
import { IProjectDataService } from "Build/Admin/Common/Services/ProjectDataService";
import { PoolsHub } from "Build/Admin/PoolsList/Components/PoolsHub";
import { Flux } from "Build/Admin/PoolsList/Flux";
import { PoolsListSignalRHub } from "Build/Admin/PoolsList/PoolsListSignalRHub";

export class PoolsListView extends VssComponent<IVssComponentProperties> {
    private _flux: Flux;
    private _breadcrumbService: HeaderBreadcrumbService;
    private _ttiMarked: boolean = false;
    private _signalRHub: PoolsListSignalRHub;

    constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props, context);
        this._flux = new Flux(context.pageContext);
        this._flux.poolsListActionCreator.initializePools();

        this._breadcrumbService = context.pageContext.getService<HeaderBreadcrumbService>(ServiceIds.HeaderBreadcrumbService);
        this._breadcrumbService.refresh({
            agentPool: undefined,
            agentQueue: undefined,
            agent: undefined
        });
    }

    public componentWillUnmount(): void {
        this._flux.dispose();

        if (this._signalRHub) {
            this._signalRHub.dispose();
        }
    }

    public componentDidMount(): void {
        if (!this._ttiMarked) {
            this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService").markTimeToInteractive(Telemetry.Area, Telemetry.PoolsListView);
            this._ttiMarked = true;
        }
    }

    public render(): JSX.Element {
        return (
            <PoolsHub
                actionCreator={this._flux.poolsListActionCreator}
                storesHub={this._flux.storesHub} />
        );
    }
}

VssComponent.register("ms.vss-build-web.admin-pools-list-view-component", PoolsListView);
